import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEven = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 200 200",
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("circle", {
			cx: 135,
			cy: 65.1,
			r: 30.5,
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 65,
			cy: 135.1,
			r: 30.5,
			fill: "currentColor"
		})] }),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {})
	]
});
export { SvgIconEven as ReactComponent };
